import { errorMessage } from "@workspace/domain/src/utils";
import { PERMISSIONS } from "@workspace/domain/src/utils/permissions";
import * as z from "zod";

const UsernameSignInSchema = z.object({
  agency: z
    .string(errorMessage("Agency username is required", "Agency username is invalid"))
    .nonempty("Agency username is required")
    .toUpperCase(),
  username: z.string(errorMessage("Username is required", "Username is invalid")).nonempty("Username is required"),
  password: z.string(errorMessage("Password is required", "Password is invalid")).nonempty("Password is required"),
});

const BaseAuthDataSchema = z.object({
  session: z.object({
    id: z.string(),
    userType: z.enum(["OWNER", "EMPLOYEE"]),
    secretHash: z.instanceof(Uint8Array),
    expiresAt: z.date(),
    userId: z.string(),
  }),
});

const EmployeeSchema = BaseAuthDataSchema.extend({
  userType: z.literal("EMPLOYEE"),
  user: z.object({
    id: z.string(),
    name: z.string(),
    username: z.string().nullable(),
    imageUrl: z.string().nullable(),
    phoneNumber: z.string().nullable(),
    agencyId: z.string(),
    permissions: z.array(z.enum(PERMISSIONS)),
  }),
});

const OwnerSchema = BaseAuthDataSchema.extend({
  userType: z.literal("OWNER"),
  user: z.object({
    id: z.string(),
    providerId: z.string(),
    name: z.string(),
    email: z.string().nullable(),
    imageUrl: z.string().nullable(),
    phoneNumber: z.string().nullable(),
    phoneNumberVerified: z.boolean(),
    agencyId: z.string().nullable(),
  }),
});

const AuthDataSchema = z.discriminatedUnion("userType", [EmployeeSchema, OwnerSchema]);

export const AdminAuth = {
  AuthData: AuthDataSchema,
  UsernameSignIn: UsernameSignInSchema,
};
export type AdminAuth = {
  AuthData: z.infer<typeof AuthDataSchema>;
  UsernameSignIn: z.infer<typeof UsernameSignInSchema>;
};
